/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_Refused_DateInputs */

const vi_einvoice_stuck_refused_date = /** @type {(inputs: Einvoice_Stuck_Refused_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA từ chối vì ngày hóa đơn. Hệ thống sẽ dùng ngày hôm nay.`)
};

/**

* @param {Einvoice_Stuck_Refused_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_refused_date = /** @type {((inputs?: Einvoice_Stuck_Refused_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Refused_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_refused_date(inputs)
});